import parser from 'content-disposition-parser';

const token = localStorage.getItem('accessToken');

export function get(path, params) {
  return sendRequest({ method: 'GET', path, query: params });
}

export function download(path, params) {
  return sendRequest({ isFile: true, method: 'GET', path, query: params });
}

export function post(path, params) {
  return sendRequest({ data: params, method: 'POST', path });
}

export function put(path, params) {
  return sendRequest({ data: params, method: 'PUT', path });
}

export function patch(path, params) {
  return sendRequest({ data: params, method: 'PATCH', path });
}

export function del(path, params) {
  return sendRequest({ method: 'DELETE', path, query: params });
}

export function upload(path, file) {
  const formData = new FormData();
  formData.append('file', file);
  return sendRequest({ formData, method: 'POST', path });
}

// private

async function sendRequest(options) {
  const init = { headers: {}, method: options.method };
  init.headers['Authorization'] = `Bearer ${token}`;
  if (options.data) {
    init.headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify(options.data);
  }
  if (options.formData) {
    init.body = options.formData;
  }
  const response = await fetch(options.path, init);
  return processResponse(response, options);
}

async function processResponse(response, options) {
  if (response.ok) {
    const data = await getResponseData(response, options);
    return data;
  } else {
    if ([401, 403].includes(response.status)) {
      timeoutRedirect();
    } else {
      const error = Error(`API Error ${response.status}`);
      error.status = response.status;
      error.data = await response.text();
      throw error;
    }
  }
}

async function getResponseData(response, options) {
  if (options.isFile) {
    const contentType = response.headers.get('Content-Type');
    const contentDisposition = response.headers.get('Content-Disposition');
    const fileName = getFileName(contentDisposition);
    const file = await response.arrayBuffer();
    return { file, fileName, fileType: contentType };
  } else {
    const text = await response.text();
    if (!text) {
      return {};
    }
    const first = text.charAt(0);
    if (first !== '{') {
      return { text };
    }
    return JSON.parse(text);
  }
}

const timeoutRedirect = () => {
  return setTimeout(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('logout');
    }
  }, 100);
};

const getFileName = (nameString) => {
  const fileOptions = parser(nameString);
  return fileOptions.filename ? fileOptions.filename : 'file';
};
